
import { Box, Button, Modal } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import TimeLeft from '../../partial/TimeLeft';
import { useEditMultiTaskMutation } from './tasksApiSlice';
import { useEffect, useState } from 'react';
const TaskEditMulti = ({selected, setSelected, setShowModal}) => {
    const navigate = useNavigate()
    const {id, groupId, type} = useParams()
    const [editDt, setEditDt] = useState(false)
    const [active, setActive] = useState(-1)
    const [dt, setDt] =  useState(new Date(new Date().setDate(new Date().getDate() + 7)))




    const [editMultiEvent, {isSuccess, data, error, isError}] = useEditMultiTaskMutation()
    useEffect(()=>{
        if(isSuccess){
           setShowModal(false)
           setSelected([])
           navigate(`/${type}/${groupId}/tasks`)
        }

    },[isSuccess])

    const handleClick = () => {
        if(!selected?.length) {
            alert("please select task bases")
            return
        }
        editMultiEvent({editDt, active, dt, selected})
       
      };



    const errClass = (isError ) ? "errmsg" : "offscreen"
 
    const errContent = (error?.data?.message) ?? ''
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        color:'black',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
      };
    const handleClose = () => {
        setShowModal(false)
      };
  return (
    <Modal
  open={true}
  onClose={handleClose}
  aria-labelledby="parent-modal-title"
  aria-describedby="parent-modal-description"
>
  <Box sx={{ ...style, width: 500 }}>
  <p className={errClass}>{errContent}</p>
  <div >
        <h1> עדכון מרובה של משימות  </h1>

        <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="edit-dt">
                   עדכון תאריך וזמן לכל המשימות:
                    <input
                        className="form__checkbox"
                        id="edit-dt"
                        name="edit-dt"
                        type="checkbox"
                        checked={editDt}
                        onChange={(e)=>setEditDt(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
             {editDt  &&    <div className="form-input-container">

                 <label className="form__label form__title-row" htmlFor="dt">
                   <span> To Date:</span> <small > (<TimeLeft endtime={dt} />)</small> </label>
                <input
                    className={`form__input  ${!dt &&'form__input--incomplete'}`}
                    id="dt"
                    name="dt"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${dt.getFullYear().toString()}-${(dt.getMonth() + 1).toString().padStart(2, 0)}-${dt.getDate().toString().padStart(2, 0)}T${dt.getHours().toString().padStart(2, 0)}:${dt.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setDt(new Date(e.target.value))}
                />
                </div>}
                <div className="form-input-container">
                <label className="form__label form__checkbox-container" htmlFor="active">
                    עדכון פעיל למשימות נבחרות</label>
                <select
                    id="active"
                    name="active"
                    className={`form__input `}
                    value={active}
                    onChange={(e)=>setActive(e.target.value)}
                >
                    <option value={-1}> ללא עדכון </option>
                    <option value={1}> עדכן לפעיל</option>
                    <option value={0}> עדכן לא פעיל</option>

                </select>
                    </div>
                    </div>
                    <div className="buttons-pan">
                    <Button color="error" variant="contained" onClick={handleClose} >Close</Button>
                <Button variant="contained" onClick={handleClick} >עדכון מרובה</Button>
                </div>
    
  </Box>
</Modal>
  )
}

export default TaskEditMulti